<template lang="pug">
  div
    el-dialog(
      title='Visualizar modelo - Notificação'
      :visible.sync='showModal'
      width='60%'
    )
      div(style="display:flex;")
        span.label Assunto: &nbsp
      .box {{ modelo.assunto }}
      .conteudo
        span.label Conteúdo: &nbsp
      .box(v-html='modelo.conteudo')

      el-row(style='padding-top: 50px;')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-arrow-left
          span Voltar

</template>
<script>
export default {
  props: {
    modalOpen: {
      type: Boolean,
      default: false,
    },
    modelo: {
      type: Object,
      required: false,
    },
  },

  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },

  methods: {
    fecharModal() {
      this.$emit('close-modal');
    },
  }

}
</script>
<style lang="scss" scoped>
.label {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 15px;
}

.conteudo {
  display: flex;
  padding-top: 30px;
}

.box {
  border: 1px solid;
  border-radius: 10px;
  padding: 10px;
  border-color: #d9d9d9;
}
</style>
